import { Carer, UserRole } from '@lmc/ts-common'
import { useSelector } from 'react-redux'
import useAbilityStore from './useAbilityStore'

export type RoleAbilityProp = { i: string; this: string }[]

export type RoleAccessProp = UserRole | UserRole[]

const useRoleAccess = (
  roles: RoleAccessProp,
  abilities?: RoleAbilityProp
): boolean | undefined => {
  const userRole = useSelector(
    (state: { global: { user: Carer } }) => state.global.user?.role
  )

  const roleAccess = Array.isArray(roles)
    ? roles.includes(userRole)
    : userRole === roles

  const abilityInstance = useAbilityStore()

  if (abilities?.length) {
    return (
      roleAccess ||
      abilities?.some((ability) =>
        abilityInstance?.can(ability.i, ability.this)
      )
    )
  }

  return roleAccess
}

export default useRoleAccess
